// @ts-nocheck
// DOM event delegation and application bootstrap.

import {
  AiImageGenerator,
  IMAGE_INPUT_PREFIX,
  IMAGE_PREVIEW_PREFIX,
  UPLOAD_AREA_SELECTOR,
  getAiImageGeneratorInstance,
  getUploadIndexFromAreaId,
} from 'ai-image-generator-app';
import {
  initPersonModeUi,
  getPersonModeConfig,
  hasRequiredReferenceImages,
} from 'ai-image-generator-person-mode';

// Keep bootstrap logging local so a cached app module cannot break the entire
// generator when diagnostic helpers change between asset deployments.
function aiImageDebugLog(...args) {
  if (window.AI_IMAGE_GENERATOR_DEBUG === true) {
    window.console.log(...args);
  }
}

function initializeAiImageGeneratorDom() {
  aiImageDebugLog('AI Image Generator 初始化中...');
  
  // 检查上传区域数量 - 同时匹配两种格式
  const uploadAreas = document.querySelectorAll(UPLOAD_AREA_SELECTOR);
  aiImageDebugLog('找到上传区域数量:', uploadAreas.length);
  
  // 为每个区域添加拖拽样式
  uploadAreas.forEach((area, index) => {
    aiImageDebugLog(`初始化区域 ${index + 1}:`, area.id);
  });
  
  // 初始化按钮状态
  setTimeout(() => {
    updateGlobalGenerateButtonState();
  }, 100);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAiImageGeneratorDom, { once: true });
} else {
  initializeAiImageGeneratorDom();
}

// 点击事件委托 - 处理上传区域点击
document.addEventListener('click', function(e) {
  const area = e.target.closest(UPLOAD_AREA_SELECTOR);
  if (area) {
    const areaId = area.id;
    const index = getUploadIndexFromAreaId(areaId);
    const inputId = `${IMAGE_INPUT_PREFIX}${index}`;
    const input = document.getElementById(inputId);
    
    aiImageDebugLog('点击上传区域:', areaId, '对应的输入框:', inputId);
    
    if (input) {
      input.click();
    } else {
      console.error('找不到对应的输入框:', inputId);
    }
  }
});

// 拖拽事件委托
document.addEventListener('dragover', function(e) {
  const area = e.target.closest(UPLOAD_AREA_SELECTOR);
  if (area) {
    e.preventDefault();
    area.classList.add('dragover');
  }
});

document.addEventListener('dragleave', function(e) {
  const area = e.target.closest(UPLOAD_AREA_SELECTOR);
  if (area) {
    e.preventDefault();
    area.classList.remove('dragover');
  }
});

document.addEventListener('drop', function(e) {
  const area = e.target.closest(UPLOAD_AREA_SELECTOR);
  if (area) {
    e.preventDefault();
    area.classList.remove('dragover');
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const index = getUploadIndexFromAreaId(area.id);
      handleFileSelect(files[0], index);
    }
  }
});

// 文件选择事件委托
document.addEventListener('change', function(e) {
  if (e.target.id && e.target.id.startsWith(IMAGE_INPUT_PREFIX)) {
    const index = e.target.id.replace(IMAGE_INPUT_PREFIX, '');
    if (e.target.files.length > 0) {
      handleFileSelect(e.target.files[0], index);
    } else {
      // 如果文件被清空，也需要更新按钮状态
      updateGlobalGenerateButtonState();
    }
  }
});

// 处理文件选择
function handleFileSelect(file, index) {
  aiImageDebugLog('处理文件:', file.name, '索引:', index);
  
  // 统一调用 AiImageGenerator 实例来处理文件，并启动裁剪流程
  const aiImageGenerator = getAiImageGeneratorInstance();
  if (aiImageGenerator) {
    aiImageGenerator.state.croppingIndex = index;
    aiImageGenerator.handleFile(file);
  } else {
    console.error('AiImageGenerator 实例未找到');
    // 提供一个无裁剪的回退方案
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      const previewId = `${IMAGE_PREVIEW_PREFIX}${index}`;
      const preview = document.getElementById(previewId);
      if (preview) {
        reader.onload = function(e) {
          preview.src = e.target.result;
          preview.style.display = 'block';
        };
        reader.readAsDataURL(file);
      }
    }
  }
}

// 全局更新生成按钮状态
function updateGlobalGenerateButtonState() {
  const aiImageGenerator = getAiImageGeneratorInstance();
  if (aiImageGenerator) {
    aiImageGenerator.updateGenerateButtonState();
    return;
  }

  const allReferenceImages = getAllReferenceImages();
  const generateBtn = document.getElementById('generate-btn');
  if (generateBtn) {
    generateBtn.disabled = !hasRequiredReferenceImages(allReferenceImages, getPersonModeConfig());
  }
}

// 从输入字段获取自动放大设置
function getAutoUpscaleValue() {
  const autoUpscaleInput = document.querySelector('input[name="properties[Auto Upscale]"]');
  return autoUpscaleInput ? autoUpscaleInput.value : 'false';
}

// 获取参考图片数量
function getReferenceImageCount() {
  const uploadAreas = document.querySelectorAll(UPLOAD_AREA_SELECTOR);
  return uploadAreas.length;
}

// 获取所有参考图片文件
function getAllReferenceImages() {
  const aiImageGenerator = getAiImageGeneratorInstance();
  if (aiImageGenerator) {
    return aiImageGenerator.getAllReferenceImages();
  }

  return Array.from(document.querySelectorAll(`[id^="${IMAGE_INPUT_PREFIX}"]`))
    .filter((input) => input.files && input.files.length > 0)
    .map((input) => input.files[0]);
}


function initializeAiImageGeneratorApp() {
  if (window.aiImageGenerator) return;

  initPersonModeUi();
  window.aiImageGenerator = new AiImageGenerator();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAiImageGeneratorApp, { once: true });
} else {
  initializeAiImageGeneratorApp();
}
